import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { SettingGet } from '../../services';

export const fetchSettingGet = createAsyncThunk(
    'settingGet/fetchSettingGet',
    async () => {
        const response = await SettingGet()
        return response.result
    }
);

const settingGetSlice = createSlice({
    name: 'settingGet',
    initialState: {
        data: null,
        status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchSettingGet.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchSettingGet.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(fetchSettingGet.rejected, (state) => {
                state.status = 'failed';
            });
    },
});

export default settingGetSlice.reducer;
